import { ValidationMode } from './validation_mode';
import { validateTag } from './tag.validator';
import { validateUser } from './user.validator';

export function validateDevice(data: Record<string , unknown>,  validationMode?: ValidationMode): string[] {
    const errors: string[] = [];

    if (!data.label) {
        errors.push('Libellé requis.');
    }

    if (!data.tagId && !data.tag) {
        errors.push('Tag requis.');
    }

    if (!data.ownerId && !data.owner) {
        errors.push('Propriétaire requis.');
    }

    if (validationMode === ValidationMode.CREATE) {
        if (!data.pinCode) {
            errors.push('Code pin requis');
        }
    }

    if (!data.baseSubscriptionId && !data.baseSubscription) {
        errors.push('Programmation requise.');
    }

    if (!data.subscriptionStart) {
        errors.push('Début d\'abonnement requis.');
    }

    if (!data.subscriptionEnd) {
        errors.push('Fin d\'abonnement requis.');
    }

    if (!data.pinCode) {
        errors.push('Code pin requis.');
    }

    if (data.tag) {
        errors.push(...validateTag(data.tag as Record<string, unknown>).map((e) => `Tag : ${e}`));
    }

    if (data.owner) {
        errors.push(...validateUser(data.owner as Record<string, unknown>).map((e) => `Utilisateur : ${e}`));
    }

    return errors;
}
